import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBack"><Path d="M20 3.91309V20.0866L7.08693 11.9998L20 3.91309Z" fill="currentColor"/><Path d="M4 3.99984H5.5V19.9998H4V3.99984Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBack;
